// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPaymentItemCustomerResponse

export type WidgetBookingPaymentItemCustomerApiResponse = {
	firstName: string;
	lastName: string;
	email: string;
};

export type WidgetBookingPaymentItemCustomer = {
	firstName: string;
	lastName: string;
	email: string;
};

export function hydrateWidgetBookingPaymentItemCustomer(data: WidgetBookingPaymentItemCustomerApiResponse): WidgetBookingPaymentItemCustomer {
	return { ...data };
}